/**
 * Dynamic API base URL — single source of truth for all API calls.
 *
 * Detection logic:
 *  - Emergent preview (*.emergentagent.com) → use REACT_APP_BACKEND_URL (env var)
 *  - localhost / 127.0.0.1               → use REACT_APP_BACKEND_URL (env var)
 *  - Production custom domain (argusxenia.com, etc.) → use window.location.origin
 *
 * The Kubernetes ingress routes /api/* → backend on ALL Argus Xenia deployments,
 * so same-origin routing always works regardless of which domain is active.
 */

const isPreviewOrLocal =
  window.location.hostname.includes("emergentagent.com") ||
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const BACKEND_URL = isPreviewOrLocal
  ? (process.env.REACT_APP_BACKEND_URL || window.location.origin)
  : window.location.origin;

export const API = `${BACKEND_URL}/api`;

/**
 * WebSocket base URL — derived from BACKEND_URL.
 * Automatically switches between wss:// (production) and ws:// (local).
 */
export const WS_BASE = BACKEND_URL
  .replace("https://", "wss://")
  .replace("http://", "ws://");
